import { create } from 'zustand';
import api from '../../../../services/api';

// Получаем строку сегодняшней даты в формате YYYY-MM-DD
const today = new Date().toISOString().split('T')[0];

export const useStore = create((set, get) => ({
  // Данные
  routes: [],
  loading: false,

  // Фильтры: по умолчанию — сегодня
  filters: {
    driver: '',
    loader: '',
    region: '',
    dateRange: { start: today, end: today }
  },

  // Выбранные маршруты
  selectedRouteIds: [],

  // Состояние модалок
  modals: {
    isFiltersOpen: false,
    isRoutesSelectorOpen: false,
    isReportOpen: false,
    isSettingsOpen: false
  },

  // Экшены
  fetchRoutes: async () => {
    set({ loading: true });
    const { filters } = get();
    try {
      const resp = await api.get('/routes/by-date', {
        params: {
          startDate: filters.dateRange.start,
          endDate: filters.dateRange.end,
          driver: filters.driver,
          loader: filters.loader,
          region: filters.region
        }
      });
      // Если у вас уже есть интерсептор, resp — это данные, а не { data: ... }
      set({ routes: resp, loading: false });
    } catch (err) {
      console.error('Error fetching routes:', err);
      set({ loading: false });
    }
  },

  setFilter: (key, value) =>
    set(state => ({
      filters: {
        ...state.filters,
        // для dateRange надо обновлять весь объект
        ...(key === 'dateRange'
          ? { dateRange: value }
          : { [key]: value })
      }
    })),

  toggleModal: name =>
    set(state => ({
      modals: {
        ...state.modals,
        [name]: !state.modals[name]
      }
    })),

  selectRoute: id =>
    set(state => {
      const sel = state.selectedRouteIds.includes(id)
        ? state.selectedRouteIds.filter(x => x !== id)
        : [...state.selectedRouteIds, id];
      return { selectedRouteIds: sel };
    }),

  clearSelection: () => set({ selectedRouteIds: [] })
}));
